import { theme, MediaQuery } from '@gower/react-ui/components';
import { provider } from './store';
import { UsersDesktop } from './desktop';
import { UsersMobile } from './mobile';

export const UsersView = provider( () => {
    return <>
        <MediaQuery minWidth={theme.current.Breakpoints.XsMin}>
            <UsersDesktop />
        </MediaQuery>
        <MediaQuery
            maxWidth={theme.current.Breakpoints.MobileMax}
        >
            <UsersMobile />
        </MediaQuery>
    </>;
}, { debug: false } );
